import React, {useEffect} from 'react'
import {connect} from '@modifi/redux'
import {selectUserIsLoading, selectUser} from '@modifi/plugin-user/register'
import PropTypes from 'prop-types'
import {ModifiUiApp} from '@modifi/ui'
import {selectIsAuthenticated} from '@modifi/plugin-authentication'
import {aInitializeUser} from '@modifi/plugin-trade'

import PageLayout from './page-layout'
import GlobalStyle from '../styles/global'

const Layout = ({children, isLoading, initLoading, isAuthenticated, init, user}) => {
  useEffect(() => {
    if (isAuthenticated) {
      if (initLoading || user) {
        return
      }
      init()
    }
  }, [init, initLoading, isAuthenticated, user])
  return (
    <ModifiUiApp>
      <PageLayout isLoading={isLoading}>{children}</PageLayout>
      <GlobalStyle />
    </ModifiUiApp>
  )
}

Layout.propTypes = {
  isLoading: PropTypes.bool,
  init: PropTypes.func.isRequired,
  initLoading: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  user: PropTypes.object,
  children: PropTypes.node,
}

Layout.defaultProps = {
  isLoading: null,
  children: null,
  user: {},
}

const mapStateToProps = state => ({
  user: selectUser(state),
  initLoading: selectUserIsLoading(state),
  isAuthenticated: selectIsAuthenticated(state),
})
const mapDispatchToProps = {
  init: aInitializeUser,
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
